export const pluralize = (n, singular, plural = undefined) =>
  n === 1 ? `${n} ${singular}` : `${n} ${plural || singular + 's'}`
